//* create a new date without hrs/min/sec
//eslint-disable-next-line
import { format, parseISO } from 'date-fns'
export default {
    methods:{
        getDate(value){
            if(value == undefined){ return '' }
            let date = value;
            if(date !== ''){
                if(typeof date === 'string'){
                    date = parseISO(date);
                }
                return format(date, 'dd-MMM-yyyy');
            }
            else{
                return '';
            }
        }
    }
}